import { ApiClient } from 'utils/apiClient';

const userService = {
  switcher: async () => {
    return ApiClient.get('users/switcher/', {});
  }
};

export default userService;
